import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  skeleton: {
    width: '100%',
    backgroundColor: ({ depth }: { depth: number }) =>
      depth === 1
        ? theme.palette.grey[300]
        : depth === 2
        ? theme.palette.grey[200]
        : theme.palette.grey[100],
    height: ({ depth }: { depth: number }) =>
      depth === 1 ? 80 : depth === 2 ? 70 : 60
  }
}))

export default useStyles
